<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
		beforeDestroy() {
			localStorage.clear()
		}
  }
</script>

<style>
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: PingFangSC;
  }

  html,
  body {
    font-size: 14px;
    margin: 0 !important;
    padding: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 0;
  }

  img {
    width: 100%;
    height: 100%;
  }
  @font-face {
    font-family: 'iconfont';  /* Project id 2855417 */
    src: url('http://at.alicdn.com/t/c/font_2855417_qmpvhvofubc.woff2?t=1661085527973') format('woff2'),
         url('http://at.alicdn.com/t/c/font_2855417_qmpvhvofubc.woff?t=1661085527973') format('woff'),
         url('http://at.alicdn.com/t/c/font_2855417_qmpvhvofubc.ttf?t=1661085527973') format('truetype');
  }

  .iconfont {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
  }

  
</style>



// WEBPACK FOOTER //
// src/App.vue